import React, { useState, useEffect } from 'react';
import { db } from '../../firebase-config';
import { collection, query, where, getDocs, doc, getDoc, setDoc } from "firebase/firestore";
import "../../Styles/SWOTComponent.css"

function SWOTComponent({ isAdmin, selectedCompany }) {
  const [swot, setSwot] = useState({ strengths: '', weaknesses: '', opportunities: '', threats: '' });
  const [companyID, setCompanyID] = useState(null);
  const [isEditable, setIsEditable] = useState(isAdmin); 

  
  useEffect(() => {
    const fetchCompanyId = async () => {
      const q = query(collection(db, "companies"), where("company", "==", selectedCompany));
      const querySnapshot = await getDocs(q);

      const companyDoc = querySnapshot.docs.find(doc => doc.data().company === selectedCompany);
      if (companyDoc) {
        setCompanyID(companyDoc.id); 
      } else {
        console.log("No matching company found");
      }
    };

    if (selectedCompany) {
      fetchCompanyId();
    }
  }, [selectedCompany]);

  
  useEffect(() => {
    const fetchSWOT = async () => {
      if (companyID) {
        const swotDocRef = doc(db, "companies", companyID, "SWOT", "current");
        const swotDocSnap = await getDoc(swotDocRef);

        if (swotDocSnap.exists()) {
          setSwot(swotDocSnap.data()); 
        } else {
          console.log("No SWOT data found for this company");
        }
      }
    };

    if (companyID) {
      fetchSWOT();
    }
  }, [companyID]);

  
  useEffect(() => {
    setIsEditable(isAdmin);
  }, [isAdmin]);

  const handleSave = async () => {
    if (companyID && isAdmin) {
      const swotDocRef = doc(db, "companies", companyID, "SWOT", "current");
      try {
        await setDoc(swotDocRef, swot);
        console.log("SWOT data saved for company ID:", companyID);
      } catch (error) {
        console.error("Error saving SWOT data:", error);
      }
    } else {
      console.log("No company ID found or user is not an admin, cannot save SWOT data");
    }
  };

  const handleChange = (event) => {
    if (isAdmin) {
      const { name, value } = event.target;
      setSwot(prevSwot => ({ ...prevSwot, [name]: value }));
    }
  };

  return (
    <>
    <h3 className="sub-header">SWOT Analyse for {selectedCompany}</h3>
    <div className="swot-grid">
      <div className="swot-cell swot-strengths">
        <h2>Strengths</h2>
        <textarea 
          readOnly={!isAdmin} 
          name="strengths" 
          placeholder="Enter strengths here" 
          value={swot.strengths} 
          onChange={handleChange}
          className={`swot-textarea ${!isAdmin ? 'swot-readOnly' : ''}`}
        />
      </div>
      <div className="swot-cell swot-weaknesses">
        <h2>Weaknesses</h2>
        <textarea 
          readOnly={!isAdmin} 
          name="weaknesses" 
          placeholder="Enter weaknesses here" 
          value={swot.weaknesses} 
          onChange={handleChange}
          className={`swot-textarea ${!isAdmin ? 'swot-readOnly' : ''}`}
        />
      </div>
      <div className="swot-cell swot-opportunities">
        <h2>Opportunities</h2>
        <textarea 
          readOnly={!isAdmin} 
          name="opportunities" 
          placeholder="Enter opportunities here" 
          value={swot.opportunities} 
          onChange={handleChange}
          className={`swot-textarea ${!isAdmin ? 'swot-readOnly' : ''}`}
        />
      </div>
      <div className="swot-cell swot-threats">
        <h2>Threats</h2>
        <textarea 
          readOnly={!isAdmin} 
          name="threats" 
          placeholder="Enter threats here" 
          value={swot.threats} 
          onChange={handleChange}
          className={`swot-textarea ${!isAdmin ? 'swot-readOnly' : ''}`}
        />
      </div>
      {isAdmin && <button className="swot-button" onClick={handleSave}>Save SWOT</button>}
    </div>
    </>
  );

}

export default SWOTComponent;

